import { useState } from "react";
import Win10Card from "../Win10Card";
import UurToevoegenModal from "../modals/UurToevoegenModal";

export default function UrenCard({ werkbon, financial, onRefresh }) {
  const [modalOpen, setModalOpen] = useState(false);
  const uren = Array.isArray(financial?.hourEntries) ? financial.hourEntries : [];

  const formatDatum = (d) => {
    if (!d) return "";
    const date = new Date(d);
    if (Number.isNaN(date.getTime())) return "";
    return date.toLocaleDateString("nl-NL");
  };

  return (
    <>
      <Win10Card title="Urenregistratie">
        {uren.length > 0 ? (
          uren.map((u, i) => (
            <div key={i} className="border-b pb-2 mb-2 text-sm">
              <p className="font-medium">{formatDatum(u.datum)}</p>
              <p>
                {Number(u.hours || 0).toFixed(2)} uur{" "}
                <span className="text-gray-600">({u.hourTypeName || "uur"})</span>
              </p>
              {u.description ? <p className="text-gray-600">{u.description}</p> : null}
            </div>
          ))
        ) : (
          <p className="text-gray-500">Nog geen uren toegevoegd.</p>
        )}

        <button
          onClick={() => setModalOpen(true)}
          className="bg-blue-600 text-white px-3 py-2 mt-2 rounded"
        >
          + Uur toevoegen
        </button>
      </Win10Card>

      {modalOpen && (
        <UurToevoegenModal
          werkbonId={werkbon._id}
          onClose={() => setModalOpen(false)}
          onSave={() => {
            setModalOpen(false);
            onRefresh?.();
          }}
        />
      )}
    </>
  );
}
